export const personaCheckboxSelectMessageLabel = "aMb";
export const personaCheckboxSelectConversationLabel = "bMb";
export default {personaCheckboxSelectMessageLabel,personaCheckboxSelectConversationLabel};